<template>
  <el-dialog :visible.sync="dialogFormVisible"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="form">
      <el-form-item label="活动标题：">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="举办城市：">
        <el-input v-model="form.city"></el-input>
      </el-form-item>
      <el-form-item label="举办详细地址：">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item label="报名人数：">
        <el-input v-model="form.limit"
                  type="number"></el-input>
      </el-form-item>
      <el-form-item>
        <p>报名简介:</p>
        <!-- <el-input v-model="form.summary"></el-input> -->
        <div contenteditable="true"
             class="editable"
             v-html="form.summary"
             @input="changeText"></div>
      </el-form-item>
      <el-form-item label="开始时间：">
        <el-date-picker v-model="form.startTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        value-format="timestamp">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间：">
        <el-date-picker v-model="form.expireTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        value-format="timestamp">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="短信报名时间：">
        <el-date-picker v-model="form.signupTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        value-format="timestamp">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="报名头图">
        <el-upload action="/file/api/file/ad"
                  
                   class="one-line-upload"
                   :on-success="enrollHeadSuccess"
                   :on-remove="headRemove">
          <el-button size="small"
                     type="primary">
            上传头图
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
        <el-input v-model="form.head"
                  placeholder="相同图片可以复制之前已上传后的链接粘贴于此，可节省时间" />
      </el-form-item>
      <el-form-item>
        <p>报名必填项</p>
        <div>

          <el-checkbox-group v-model="checkNoNeed">
            <el-checkbox v-for="item in allNeed"
                         :label="item.value"
                         :key="item.value">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="closeDialog(false)">取 消</el-button>
      <el-button type="primary"
                 @click="setenroll">{{
        this.form.id ? "更 新" : "新 增"
      }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "edit_enroll",
  props: ["info"],
  data() {
    return {
      dialogFormVisible: true,
      deleteInvoiceDialog: false,
      agreementName: null,
      summary: null,
      checkNoNeed: [],
      allNeed: [
        {
          name: "名片",
          value: "card"
        },
        // {
        //   name: "地址",
        //   value: "city"
        // },
        {
          name: "公司",
          value: "company"
        },
        {
          name: "职位",
          value: "job"
        },
        {
          name: "邮箱",
          value: "mail"
        },
        {
          name: "备注",
          value: "remark"
        },
        {
          name: "联络人",
          value: "concatPerson"
        },
        {
          name: "微信",
          value: "wechat"
        }
      ],
      //       card:null
      // city:null
      // company:null
      // job:null
      // mail:null
      // remark:""
      // wechat:null
      form: {
        id: null,
        summary: "",
        type: "enroll",
        title: null,
        city: null,
        limit: null,
        status: 1,
        startTime: null,
        expireTime: null,
        head: "",
        address: "",
        signupTime: null,
        noNeed: []
      },
      oss: {
        key: "",
        OSSAccessKeyId: "",
        policy: "",
        Signature: "",
        host: "",
        success_action_status: 200,
        callback: ""
      }
    };
  },
  created() {
    this.getOssSign();
  },

  mounted() {
    this.form.id = !this.info ? null : this.info.id;
    this.form.title = !this.info ? null : this.info.title;
    this.form.city = !this.info ? null : this.info.city;
    this.form.limit = !this.info ? null : this.info.limit;
    this.form.head = !this.info ? null : this.info.head;
    this.form.summary = !this.info ? null : this.info.summary;
    this.summary = !this.info ? null : this.info.summary;
    this.form.address = !this.info ? null : this.info.address;
    this.form.startTime = !this.info ? null : this.info.startTime;
    this.form.expireTime = !this.info ? null : this.info.expireTime;
    this.form.signupTime = !this.info ? null : this.info.signupTime;
    this.form.noNeed = !this.info ? "" : this.info.noNeed;
    this.checkNoNeed = !this.info
      ? []
      : this.info.noNeed.length > 0
        ? this.info.noNeed.split(",")
        : [];
  },
  methods: {
    changeText(e) {
      console.log(e.target, e.target.innerText);
      this.summary = e.target.innerText;
    },
    getOssSign() {
      this.$http.oss_sign().then(res => {
        if (res.data.statusCode === 200) {
          this.oss.host = res.data.result.host;
          this.oss.key =
            res.data.result.dirPath + res.data.result.key + "${filename}";
          this.oss.policy = res.data.result.policy;
          this.oss.OSSAccessKeyId = res.data.result.OSSAccessKeyId;
          this.oss.Signature = res.data.result.Signature;
          this.oss.callback = res.data.result.callback;
        } else {
          this.$message({
            type: "error",
            message: "获取oss签名信息失败,请刷新重试。"
          });
        }
      });
    },
    enrollHeadSuccess(res) {
      console.log(res);
      if (res.statusCode === 200) {
        this.form.head = res.result.url;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    headRemove() {
      this.form.header = null;
    },
    async setenroll() {
      if (
        !this.form.signupTime ||
        !this.form.startTime ||
        !this.form.expireTime
      ) {
        this.$message({
          type: "error",
          message: "请填写相关时间"
        });
        return;
      }
      console.log(this.form);
      // return;
      this.form.summary =
        "<p>" + this.summary.replace(/\n/gi, "</p><p>") + "</p>";
      this.form.signupTime = +this.form.signupTime;
      this.form.noNeed = this.checkNoNeed.join(",");
      if (this.form.id) {
        console.log(this.form);
        let res = await this.$http.updateEnroll(this.form);
        if (res.data.statusCode === 200) {
          this.closeDialog(true);
        } else {
          this.$message({
            type: "error",
            message: res.data.message
          });
        }
      } else {
        let res = await this.$http.setEnroll(this.form);
        if (res.data.statusCode === 200) {
          this.closeDialog(true);
        } else {
          this.$message({
            type: "error",
            message: res.data.message
          });
        }
      }
    },
    closeDialog(type) {
      this.$emit("closeDialog", type);
    }
  }
};
</script>

<style scoped>
.editable {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
.editable:focus {
  outline: none;
  border: 1px solid #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/enroll/edit_enroll.vue